(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  // Below this width, the BTK overlay does NOT open from nav clicks.
  // Mobile (<769px, the theme's drawer) uses the inline <details> sub-list
  // rendered in sections/header.liquid instead. Native browser behaviour
  // handles the toggle - no JS needed. 769 = where the theme menu turns
  // desktop (tablets get the desktop menu row - see btk-header-menu.css).
  var DESKTOP_MIN_WIDTH = 769;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }

  // Nav label (lower-cased, trimmed) -> the overlay it opens.
  // `key` is the window.BTKHeaderMenu.* handle each overlay registers;
  // `overlay` is the element id, used to detect the already-open state.
  // Adding a new mega menu = one line here.
  var MENUS = {
    'kitchens':      { key: 'kitchens',     overlay: 'btkHMKitchens' },
    'kitchen units': { key: 'kitchenUnits', overlay: 'btkHMKitchenUnits' },
    'appliances':    { key: 'appliances',   overlay: 'btkHMAppliances' },
    'worktops':      { key: 'worktops',     overlay: 'btkHMWorktops' },
    // Facet menus. 'sinks & taps' is here too so the overlay still opens if the
    // nav keeps the live site's combined label instead of two separate items.
    'sinks':         { key: 'sinks',        overlay: 'btkHMFctSinks' },
    'sinks & taps':  { key: 'sinks',        overlay: 'btkHMFctSinks' },
    'taps':          { key: 'taps',         overlay: 'btkHMFctTaps' },
    'handles':       { key: 'handles',      overlay: 'btkHMHandles' },
    'accessories':   { key: 'accessories',  overlay: 'btkHMAccessories' }
  };

  // Panels hold different numbers of tiles, so switching rail item used to
  // resize the whole dropdown - two rows collapsing to one is a jarring jump.
  // On first open we render every panel once, keep the tallest, and pin that
  // as a min-height on the content column. Cards are aspect-ratio boxes, so
  // their height is known before any image has loaded and the measurement
  // doesn't need to wait for them.
  //
  // Rail buttons are plain <button type="button">, and clicking one is exactly
  // "render that panel" for every menu - which keeps this generic instead of
  // needing the same loop copied into all seven snippets.
  function lockPanelHeight(overlay) {
    if (!overlay || overlay.dataset.btkHeightLocked === '1') return;
    var right = overlay.querySelector('.btk-hm__right');
    var btns  = overlay.querySelectorAll('.btk-hm__left-btn');
    if (!right || btns.length < 2) return;

    var restore = overlay.querySelector('.btk-hm__left-btn.is-active') || btns[0];
    var tallest = 0;

    right.style.minHeight = '';
    btns.forEach(function (btn) {
      btn.click();
      tallest = Math.max(tallest, right.scrollHeight);
    });
    restore.click();

    if (tallest) right.style.minHeight = tallest + 'px';
    overlay.dataset.btkHeightLocked = '1';
  }

  // Column count depends on width, so a resize invalidates the measurement.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Object.keys(MENUS).forEach(function (label) {
        var overlay = document.getElementById(MENUS[label].overlay);
        if (!overlay || overlay.dataset.btkHeightLocked !== '1') return;
        var right = overlay.querySelector('.btk-hm__right');
        if (right) right.style.minHeight = '';
        overlay.dataset.btkHeightLocked = '';
        if (overlay.classList.contains('is-open')) lockPanelHeight(overlay);
      });
    }, 200);
  });

  function closeOthers(exceptKey) {
    Object.keys(MENUS).forEach(function (label) {
      var k = MENUS[label].key;
      if (k === exceptKey) return;
      var m = window.BTKHeaderMenu && window.BTKHeaderMenu[k];
      if (m) m.close();
    });
  }

  function init() {
    var navLinks = document.querySelectorAll('.main-nav__item--primary, .main-nav a');

    navLinks.forEach(function (link) {
      var text = (link.textContent || '').trim().toLowerCase();
      var cfg  = MENUS[text];
      if (!cfg) return;

      link.addEventListener('click', function (e) {
        if (!isDesktop()) return; // mobile: fall through to <details> toggle / link

        // If the overlay isn't on the page, leave the link alone so it still
        // navigates - better than swallowing the click.
        var menu = window.BTKHeaderMenu && window.BTKHeaderMenu[cfg.key];
        if (!menu) return;

        e.preventDefault();
        e.stopPropagation();

        var overlay = document.getElementById(cfg.overlay);
        if (overlay && overlay.classList.contains('is-open')) {
          menu.close();
        } else {
          closeOthers(cfg.key);
          menu.open(link);
          // open() builds the rail and the first panel synchronously; measure
          // on the next frame so the browser has laid them out.
          requestAnimationFrame(function () { lockPanelHeight(overlay); });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
